import React from "react";
import Helmet from "react-helmet";

function Terms() {
  return (
    <>
      {/* Termly Tracking Code */}

      <div
        name="termly-embed"
        data-id="199ea07a-ed2d-43b4-958a-eb7f39c11af6"
        data-type="iframe"
      ></div>
      <Helmet>
        <script type="text/javascript">{`(function(d, s, id) {
  var js, tjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = "https://app.termly.io/embed-policy.min.js";
  tjs.parentNode.insertBefore(js, tjs);
}(document, 'script', 'termly-jssdk'))`}</script>
      </Helmet>
    </>
  );
}

export default Terms;
